import React,{useState} from 'react'


const ExploreboxAccordian = (props) => {

    const[modal,showModal]=useState(false)
    const[modal1,showModal1]=useState(false)
    const[modal2,showModal2]=useState(false)

    const openModal=(one,two,three)=>{
        showModal(one);
        showModal1(two);
        showModal2(three);
    }

    return (
        <>
        <div className="events__accordian">
            <div className="events__accordian__content">
                <div className="tab" onClick={()=>openModal(true,false,false)}>
                    <h2>About</h2>
                   {modal &&  <div className="tab_content one"  id='details'>
                    <div className="div1">
                           <h3>{props.name} :</h3>
                           <p>{props.date}</p>
                       </div>
                       <div className="div2">
                           <h3>Duration</h3>
                           <p>{props.duration}</p>
                       </div>
                       <div className="div3">
                           <h3>Mode</h3>
                           <p>Live classroom</p>
                       </div>
                    </div>}
                </div>
                <div className="tab" onClick={()=>openModal(false,true,false)}>
                    <h2>Rules</h2>
                   {modal1 &&  <div className={ modal1? "tab_content two" : "two"} id='rules'>
                    <div className="div1">
                              <h3>Eligibility : <span>{props.eligibility} </span></h3>
                              <h3>Payment Instructions : <span>{props.payment}</span></h3>
                              <h3>Prerequisites : <span>{props.prerequisites}</span></h3>
                              <h3>Certificate Criterion : <span>{props.certificate} </span></h3>
                              <h5> {props.note} </h5>
                          </div>
                    </div>}
                </div>
                <div className="tab" onClick={()=>openModal(false,false,true)}>
                    <h2>Contact</h2>
                   {modal2 &&  <div className="tab_content three">
                      <h2> {props.person} </h2>
                      <h4> {props.mail} </h4>
                      <p>contact: {props.contact} </p>
                  </div>}
                </div>
            </div>
        </div>
        </>
    )
}

export default ExploreboxAccordian
